<template lang="pug">
.formatted-entry-no
  template(v-if='entryNo !== undefined && entryNo !== null')
    | {{ entryNo }}
  template(v-else)
    span.ml-2 -
  i.text-small.bold.ml-2
    | (#
    | {{ orderId }}
    | )
</template>

<script>
export default {
  props: {
    entryNo: {},
    orderId: {},
  },
};
</script>

<style lang="scss">
// .formatted-entry-no {}
</style>
